import { IconUpload } from "@tabler/icons-react";
import { useDfyImageDropzone } from "./useDfyImageDropzone";

export default function ImagesDropzone({
  onAdd,
  disabled = false,
  label,
}: {
  onAdd: (files: File[]) => void;
  disabled?: boolean;
  label?: string;
}) {
  const { getRootProps, getInputProps, isDragActive } = useDfyImageDropzone(
    onAdd,
    { disabled },
  );

  return (
    <div
      className={`flex min-h-56 cursor-pointer flex-col items-center justify-center rounded-xl border border-dashed p-8 [&_svg]:stroke-[url(#icon-gradient)] ${
        isDragActive
          ? "border-primary-400 bg-primary-100"
          : "border-border bg-file-upload"
      } ${disabled ? "pointer-events-none opacity-50" : ""}`}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <IconUpload stroke={2} size={24} />
      <div className="h-2" />
      <p className="max-w-sm text-center text-sm text-text-secondary">
        {label ?? "Click to choose images or drag here"}
      </p>
    </div>
  );
}
